/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalRecordSummaryDto } from './transmittalRecordSummaryDto.schema';

export const IReadOnlyListOfTransmittalRecordSummaryDto = zod.array(zod.lazy(() => TransmittalRecordSummaryDto));

export type IReadOnlyListOfTransmittalRecordSummaryDto = zod.input<typeof IReadOnlyListOfTransmittalRecordSummaryDto>;
export type IReadOnlyListOfTransmittalRecordSummaryDtoOutput = zod.output<typeof IReadOnlyListOfTransmittalRecordSummaryDto>;
